module.exports = __webpack_public_path__ + "static/media/cafe-menu.638d510f.jpg";